<template>
  <section>
    <category-menu v-if="rootStore.isMobile"></category-menu>

    <section class="header-image-container" v-if="!hideRijnjaContent">
      <!-- <img class="cat-arrow" src="@/images/arrow-ps-cover.svg" /> -->
      <div class="header-image">
        <div class="text-holder">
          <h1>Duizenden stickers en borden</h1>
          <h2>Kant-en-klaar, snel bezorgd.</h2>
        </div>
        <ul class="intro-text">
          <li>
            <h2>Standaard</h2>
            <p>
              Officiële signing (NEN, RVV),<br />voor veiligheid, verkeer<br />en
              regelgeving.
            </p>
          </li>
          <li>
            <h2>Uitgebreid</h2>
            <p>
              Signing voor bouwplaatsen,<br />
              afvalverwerking, gebouwen,<br />
              openbare ruimtes en evenementen.<br />
              Ook met uw eigen teksten.
            </p>
          </li>
          <li>
            <h2>Eigen ontwerpen</h2>
            <p>
              Signing met uw eigen teksten<br />
              en logo. En geheel eigen<br />
              ontwerpen in uw huisstijl.<br />
            </p>
            <button class="link-text info-btn" @click="showForm">
              Meer informatie…
            </button>
          </li>
        </ul>
        <div class="img-holder"></div>
      </div>
    </section>

    <card-holder class="recommended" v-else-if="dashboardCollections.length">
      <h1>Uitgelichte collecties</h1>
      <template v-for="item in dashboardCollections" :key="item.id">
        <collection-card
          :value="item"
          @removed="removeItem(item.id)"
          @click.native="goToCollection(item)"
        >
        </collection-card>
      </template>
    </card-holder>
    <section class="db-placeholder" v-else-if="showPlaceholder">
      <img
        v-if="!customLogo"
        id="rijnja-logo"
        class="logo"
        src="@/images/logo/rijnja_prints_voor_professionals_logo.svg"
      />
      <img v-else class="custom-logo" id="custom-logo" :src="customLogo" />

      <p>
        Kies een categorie om het aanbod te bekijken.
      </p>
    </section>
  </section>
</template>
<script>
import { getDashboardCollection } from '@/features/printstore/PrintStoreApi'
import CollectionCard from '@/features/printstore/children/CollectionCard.vue'
import CategoryMenu from './CategoryMenu.vue'
import PrintStoreMixin from '../PrintStoreMixin'
import ProductRequest from '../dialogs/CustomPrintStoreRequest'
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  components: {
    CollectionCard,
    CategoryMenu
  },
  mixins: [PrintStoreMixin],
  data() {
    return {
      dashboardCollections: [],
      showPlaceholder: false
    }
  },
  async mounted() {
    this.printStoreStore.searchString = ''
    const appendDefCats =
      !this.rootStore.theme.customFields.printStore.hideDefaultContent &&
      !this.rootStore.theme.printStore.isDefault

    const collections = await getDashboardCollection(appendDefCats)

    if (this.hideRijnjaContent) {
      this.dashboardCollections = collections
    } else {
      const shuffled = [...collections].sort(() => 0.5 - Math.random())
      this.dashboardCollections = shuffled.slice(0, 3)
    }

    if (this.dashboardCollections.length < 1) {
      this.showPlaceholder = true
    }
  },
  methods: {
    async goToCollection(col) {
      await this.$router.push({
        name: 'printStoreCollection',
        params: { categoryId: col.categoryId, collectionId: col.id }
      })
    },
    showForm() {
      this.$modal.show(ProductRequest, {}, { width: 380, height: 'auto' })
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore),
    title() {
      return this.interaction.globe.mainTitle
        ? this.interaction.globe.mainTitle
        : 'Welkom bij PrintStore'
    },
    subTitle() {
      return this.interaction.globe.mainText
        ? this.interaction.globe.mainText
        : 'Kies uit duizenden professionele ontwerpen en ontvang de prints morgen in huis!'
    },
    customLogo() {
      if (this.rootStore.theme.header.menuRight.customLogo) {
        return (
          '//images.rijnja.nl/images/logos/themes' +
          this.rootStore.theme.header.menuRight.customLogo
        )
      } else {
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.header-image-container {
  margin: 10px auto 30px;
  max-width: 877px;
  width: 100%;
  position: relative;
}
.cat-arrow {
  position: absolute;
  left: -45px;
  width: 254px;
  top: -30px;
  display: none;
}

.header-image {
  margin: 0 15px;
  overflow: hidden;
  background: white;
  border-radius: 24px;
  box-shadow: rgba(0, 0, 0, 0.5) 0 0 28px -16px;

  .text-holder {
    text-align: center;
    padding: 40px 0 0 0;
  }

  .img-holder {
    background-image: url('@/images/ss-coverimage.png');
    width: 100%;
    height: 262px;
    display: block;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  h1 {
    margin-bottom: 5px;
  }

  h2 {
    color: var(--sub-color);
    font-size: 15px;
    font-weight: 400;
  }
}
header {
  pointer-events: none;
  p {
    padding-left: 5px;
  }
}

h1 {
  font-size: 19px;
  font-weight: 500;
  margin-bottom: 10px;
  color: var(--sub-color);
}
.recommended.card-holder {
  max-width: 766px;
  justify-content: center;
  margin: 0 auto;

  h1 {
    text-align: center;
    width: 100%;
    margin-bottom: 9px;
    margin-top: 15px;
  }
}

.db-placeholder {
  text-align: center;
  padding-top: 100px;

  p {
    color: var(--sub-color);
  }

  img {
    max-width: 150px;
  }
}

.intro-text {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
  //padding: 49px 0;

  li {
    width: 213px;
    text-align: center;
    padding: 25px 0;
  }

  h2 {
    margin-bottom: 7px;
  }
}

.info-btn {
  font-size: 0.82rem;
  padding-top: 10px;
  color: var(--sub-color);
  font-weight: 500;
}

@media only screen and (min-width: 620px) {
  .header-image {
    .img-holder {
      height: 262px;
    }
  }
  header {
    margin-top: -67px;
    padding: 0 40px 25px;
  }
}

@media only screen and (min-width: 820px) {
  .header-image {
    .img-holder {
      height: 373px;
    }
  }
}

@media only screen and (min-width: 940px) {
  /* .header-image-container {
    margin-top: 30px;
  } */
  /* .cat-arrow {
    width: 240px;
    top: -26px;
    display: block;
  } */
}

@media only screen and (min-width: 1200px) {
  .recommended.card-holder {
    justify-content: space-between;
  }

  .cat-arrow {
    width: 339px;
    top: -35px;
    height: 55px;
  }

  .intro-text {
    li {
      padding: 37px 0 22px;
    }
  }
}

@media only screen and (min-width: 1345px) {
  .cat-arrow {
    width: 566px;
    height: 65px;
    left: -142px;
    top: -50px;
  }
}
</style>
